import {
  TITLE,
  PAGETITLE,
  SIDENAV_VISIBILITY,
  RESET,
  LOADING,
  ACTIVE_SIDEBAR,
  SET_SIDEBAR,
  UNSET_SIDEBAR,
  SIDENAV_COLLAPSED,
  SIDENAV_TOGGLE_COLLAPSED,
  HAS_INTERNAL_NAV,
} from '../types';

import { DEFAULT_PAGETITLE, DEFAULT_TITLE } from '../../config';

export const state = () => ({
  title: DEFAULT_TITLE,
  pageTitle: DEFAULT_PAGETITLE,
  showSideNav: false,
  sidebarCollapsed: false,
  loading: false,
  activeSidebar: null,
  hasInternalNav: false,
});

export const getters = {
  // the first argument is the module's local state
  // the second argument is the getters object itself
  // the third argument is the rootState
  //
  // we have used ES6 object destructuring
  // to pull out the pageTitle from the local state object
  [TITLE]({ title }) {
    return title;
  },

  [PAGETITLE]({ pageTitle }) {
    return pageTitle;
  },

  [SIDENAV_VISIBILITY]({ showSideNav }) {
    return showSideNav;
  },

  [SIDENAV_COLLAPSED]({ sidebarCollapsed }) {
    return sidebarCollapsed;
  },

  [LOADING]({ loading }) {
    return loading;
  },

  [ACTIVE_SIDEBAR]({ activeSidebar }) {
    return activeSidebar;
  },

  [HAS_INTERNAL_NAV]({ hasInternalNav }) {
    return hasInternalNav;
  },
};

// committing a mutation method can be done in components
// as follows: this.$store.commit('mutationName');
//
// notice that the functions MUST be synchronous
export const mutations = {
  // used 'stateObj' over the 'state'
  // according to the ESLint's 'no-shadow' rule
  /* eslint-disable no-param-reassign */

  // commented the rootState as it has not been implemented yet!
  // See: https://github.com/vuejs/vuex/issues/344
  [TITLE](stateObj, title) {
    stateObj.title = title;
  },

  [PAGETITLE](stateObj, /* rootState, */ pageTitle) {
    stateObj.pageTitle = pageTitle;
  },

  [SIDENAV_VISIBILITY](stateObj, /* rootState, */ visibility) {
    stateObj.showSideNav = visibility;
  },

  [SIDENAV_TOGGLE_COLLAPSED](stateObj) {
    stateObj.sidebarCollapsed = !stateObj.sidebarCollapsed;
  },

  [RESET](stateObj) {
    Object.assign(stateObj, state());
  },

  [LOADING](stateObj, value) {
    stateObj.loading = value;
  },

  [SET_SIDEBAR](stateObj, newSidebarConfig) {
    stateObj.activeSidebar = newSidebarConfig;
  },

  [UNSET_SIDEBAR](stateObj) {
    stateObj.activeSidebar = null;
  },

  [HAS_INTERNAL_NAV](stateObj, hasInternalNav) {
    stateObj.hasInternalNav = hasInternalNav;
  },
};

// actions are reusable complex functions,
// shared between components to commit mutations and
// can be dispatched through components as follows:
// this.$store.dispatch('actionName');
//
// notice that actions can be asynchronous
export const actions = {
  // the first argument is the context store,
  // i.e. the locale module object
  [TITLE]({ commit }, title) {
    commit(TITLE, title);
  },

  [PAGETITLE]({ commit }, pageTitle) {
    commit(PAGETITLE, pageTitle);
  },

  [SIDENAV_VISIBILITY]({ commit }, visibility) {
    commit(SIDENAV_VISIBILITY, visibility);
  },

  [SIDENAV_TOGGLE_COLLAPSED]({ commit }) {
    commit(SIDENAV_TOGGLE_COLLAPSED);
  },

  [LOADING]({ commit }, loading) {
    commit(LOADING, loading);
  },

  [SET_SIDEBAR]({ commit }, newSidebarConfig) {
    commit(SET_SIDEBAR, newSidebarConfig);
  },

  [UNSET_SIDEBAR]({ commit }) {
    commit(UNSET_SIDEBAR);
  },

  [HAS_INTERNAL_NAV]({ commit }, hasInternalNav) {
    commit(HAS_INTERNAL_NAV, hasInternalNav);
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
